import { ODataError } from "./odata-error";

export class ODataCustomError extends Error {
    constructor(message: string, public data: ODataError) {
        super();
        this.message = message;
    }
}
